import './src/styles/global.scss';
import { ApiProvider } from './src/contexts/api.context';
import React from 'react';

const appModalRoot = document.createElement('div');
appModalRoot.id = 'bottom-sheet-modal';
document.body.appendChild(appModalRoot);

export const wrapRootElement = ({ element }) => <ApiProvider>{element}</ApiProvider>;